(function () {
  function initCardSwipers() {
    document.querySelectorAll('.j4all-card-swiper').forEach(function (swiper) {
      if (swiper.dataset.j4allInit) return;
      swiper.dataset.j4allInit = 'true';

      var bar = swiper.querySelector('.j4all-card-progress__bar');
      var slideEls = swiper.querySelectorAll('.j4all-card-slide');
      var count = slideEls.length;

      if (count <= 1) return;

      var slides = swiper.querySelector('.j4all-card-slides');
      if (!slides) return;

      // Progress bar
      if (bar) {
        slides.addEventListener('scroll', function () {
          var maxScroll = slides.scrollWidth - slides.clientWidth;
          if (maxScroll <= 0) return;
          var ratio = slides.scrollLeft / maxScroll;
          var translate = ratio * (count - 1) * 100;
          bar.style.transform = 'translateX(' + translate + '%)';
        }, { passive: true });
      }

      // Tap vs swipe detection
      var startX = 0;
      var startY = 0;
      var isSwiping = false;

      slides.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isSwiping = false;
      }, { passive: true });

      slides.addEventListener('touchmove', function (e) {
        var dx = Math.abs(e.touches[0].clientX - startX);
        var dy = Math.abs(e.touches[0].clientY - startY);
        if (dx > 10) isSwiping = true;
      }, { passive: true });

      slides.addEventListener('click', function (e) {
        if (isSwiping) {
          e.preventDefault();
          return;
        }
        var link = swiper.closest('.card-wrapper').querySelector('a[href]');
        if (link) window.location.href = link.href;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardSwipers);
  } else {
    initCardSwipers();
  }

  var observer = new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) {
      if (m[i].addedNodes.length) { initCardSwipers(); return; }
    }
  });
  function observe() {
    document.querySelectorAll('#ProductGridContainer, [id^="Slider-"], product-recommendations, .related-products').forEach(function (el) {
      observer.observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
  document.addEventListener('shopify:section:load', initCardSwipers);
})();